import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { get, toLower, trim, upperFirst } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimesCircle } from "@fortawesome/pro-solid-svg-icons";
import { Loader } from "../";
import { useComponentDidUpdate } from "../../abstracts";
import tenantConfig from "../../mocks/tenantOne.json";
import { warningCodes } from "../../utils/constants/warningCodes";

const FormControl = ({
  label,
  name,
  children,
  isRequired,
  hasSuggestion,
  value,
  suggestionDefaultText,
  isSuggestionLoading,
  isValidSuggestion,
  suggestionErrorMessage,
  shouldDisplaySuggestion,
  size = "md",
  isSuggestionTextItalic,
  noLabelTransform,
  customErrorCode,
  customErrorMessage,
  astriex = false,
  showTickAlways = false,
  ignoreError = false,
  isCensusPayrollError = false,
  ...rest
}) => {
  const [showTick, setShowTick] = useState(showTickAlways);
  const [showClass, setShowClass] = useState(true);
  const { submitCount } = rest;
  useComponentDidUpdate(() => {
    if (!isSuggestionLoading) {
      setShowTick(true);
    }
  }, [isSuggestionLoading]);

  const fullText = () => {
    setShowClass(!showClass);
  };

  let className = label && isRequired ? "required" : "";
  let labelClass = noLabelTransform ? "nolabelTransform" : "";
  const errors = get(rest, `errors`, {});
  const errorMessage = get(errors, name) || errors[name] || "";
  const isTouched = submitCount > 0 || get(rest, `touched.${name}`);
  const warningCheck =
    isCensusPayrollError &&
    warningCodes.includes(errorMessage.slice(0, errorMessage.indexOf(" -")));
  const isInvalid =
    !!errorMessage || (showTick && hasSuggestion && !isValidSuggestion);
  className = isInvalid
    ? warningCheck
      ? `${className} invalid-warning`
      : `${className} invalid`
    : className;
  const suggestionTextClass = isSuggestionTextItalic ? "italic" : "";
  let childControls = children;

  if (hasSuggestion) {
    const suggestionCheckClass = isValidSuggestion ? "valid" : "invalid";
    childControls = (
      <div className="d-flex">
        {children}
        {isSuggestionLoading && (
          <span className="check-cirle">
            <Loader size="sm" loaderText="" />
          </span>
        )}
        {(shouldDisplaySuggestion ||
          (!isSuggestionLoading && !value && suggestionDefaultText)) && (
          <span className={`suggest-text ${suggestionTextClass}`}>
            {suggestionDefaultText}
          </span>
        )}
        {!isSuggestionLoading && showTick && (
          <span className={`check-cirle ${suggestionCheckClass}`}>
            <FontAwesomeIcon
              icon={isValidSuggestion ? faCheckCircle : faTimesCircle}
              size="sm"
            />
          </span>
        )}
      </div>
    );
  }
  const transformedLabel = Object.keys(
    tenantConfig.custom_field_label
  ).includes(name)
    ? tenantConfig.custom_field_label[name]
    : noLabelTransform
    ? label
    : upperFirst(toLower(label));

  return (
    !tenantConfig.hide_field[name] && (
      <Form.Group className={`${className} ${size}`}>
        {label !== undefined && (
          <Form.Label className={labelClass}>
            {transformedLabel}&nbsp;
            {!isRequired && trim(label) && (
              <span className="optional-side-text">(Optional)</span>
            )}
            {astriex && trim(label) && (
              <span
                style={{ marginTop: "20px", fontSize: "14px", color: "red" }}
              >
                *
              </span>
            )}
          </Form.Label>
        )}
        {childControls}
        {isInvalid && (
          <>
            {customErrorCode && (
              <Form.Control.Feedback className="invalid-feedback">
                {customErrorCode}
              </Form.Control.Feedback>
            )}
            <Form.Control.Feedback className="invalid-feedback">
              <div>{customErrorMessage || suggestionErrorMessage}</div>
            </Form.Control.Feedback>
            {errorMessage && !ignoreError && (
              <Form.Control.Feedback className="invalid-feedback">
                {isCensusPayrollError ? (
                  <div
                    className={
                      warningCheck ? "warning-msg-payroll" : "error-msg-payroll"
                    }
                    // style={{
                    //   border: "1px solid #F3C3CB",
                    //   backgroundColor: "#F3C3CB",
                    //   borderRadius: "8px",
                    //   padding: "1%",
                    // }}
                  >
                    <div
                      className={
                        warningCheck
                          ? "font-weight-msg warning-msg-text"
                          : "font-weight-msg error-msg-text"
                      }
                      // style={{
                      //   fontWeight: "700",
                      //   color: "#D0273D",
                      // }}
                    >
                      {warningCheck ? "Warning Code : " : "Error Code : "}
                      {errorMessage.slice(0, errorMessage.indexOf(" -"))}
                      <br />
                    </div>
                    <div
                      className={
                        warningCheck ? "warning-msg-text" : "error-msg-text"
                      }
                      // style={{
                      //   color: "#D0273D",
                      // }}
                    >
                      {" "}
                      {errorMessage.slice(
                        errorMessage.indexOf(" -") + 2,
                        errorMessage.length
                      )}
                    </div>
                  </div>
                ) : (
                  errorMessage
                )}
              </Form.Control.Feedback>
            )}
          </>
        )}
      </Form.Group>
    )
  );
};

export default FormControl;
